export default "__VITE_ASSET__e9888031__"